<template>
    <div>
        <div class="row px-5 mt-5">
            <div class="col-12" v-if="data"
                                v-html="data">
            </div>

            <div class="col-12" v-if="!data">
                <h1>Esta sección aún esta pendiente de edición por parte del administrador.</h1>
            </div>
        </div>
    </div>
</template>

<script>
import { getTemplateId } from '../../utils';

import Template1 from '../Shared/Layouts/Template1.vue';
import Template2 from '../Shared/Layouts/Template2.vue';

export default {

    layout: getTemplateId() == 1 ? Template1 : Template2,

    props: {

        data: {
            type: String,
            required: true,
        },

    },

    mounted() {

        $('#main-body').removeClass('gray-background');

    },

};
</script>
